import { Desc, Description, Icon, Title, Wrapper } from './Items';
import FeatureDBL from '../../assets/features/feature_double_chance.png';
import Switch from '../../assets/features/switch.png';
import { TEXTS } from '../../helpers/content';
import { FeatureBox } from '../ContentStyled';
import { GameConfigs } from '../../../lib/globals/GameConfigs';
export default function DoubleChance({
	scale,
	currentBet,
	doubleChance,
	currency,
	config
}) {
	const current = config.double_steps[config.bet_steps.indexOf(currentBet)];

	return (
		<FeatureBox>
			<Description scale={scale}>{TEXTS.features[0].double_desc_1}</Description>
			<Wrapper scale={scale}>
				<div className='text'>
					<Title scale={scale}>
						{currency}
						{(+current).toLocaleString(undefined, {
							minimumFractionDigits: GameConfigs.config.currency_prec,
							maximumFractionDigits: GameConfigs.config.currency_prec
						})}
					</Title>
					<Desc scale={scale}>
						Double Chance <br /> to win <span>feature</span>
					</Desc>
					<div className='switch'>
						<img src={Switch} alt='feature' />
					</div>
				</div>
				<Icon scale={scale}>
					<img src={FeatureDBL} alt='feature' />
				</Icon>
			</Wrapper>
			<Description scale={scale}>
				{TEXTS.features[0].double_desc_2} {doubleChance}%
			</Description>
		</FeatureBox>
	);
}
